module.exports = __webpack_public_path__ + "static/media/pubg1.67bab8e3.jpg";